/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SsoPolicyModule
 */

import { Injector } from '@angular/core';

import {
    SsoPolicyCollection,
} from 'ajs/modules/sso-policy/factories/sso-policy.collection.factory';

import {
    SSO_POLICY_COLLECTION_TOKEN,
} from 'ajs/modules/sso-policy/sso-policy.tokens';

const $injector = '$injector';

export const authProfileCollectionProvider = {
    deps: [$injector],
    provide: 'AuthProfileCollection',
    useFactory(injector: Injector): any {
        return injector.get('AuthProfileCollection');
    },
};

export const ssoPolicyCollectionProvider = {
    deps: [$injector],
    provide: SsoPolicyCollection,
    useFactory(injector: Injector): typeof SsoPolicyCollection {
        return injector.get(SSO_POLICY_COLLECTION_TOKEN);
    },
};
